export default {
  pt: {
    'auth.semAcesso.titulo': 'Seu acesso ainda não inclui nenhuma área',
    'auth.semAcesso.explicacao':
      'A conta está ativa, mas nenhuma área do sistema foi liberada para ela, ou a área liberada ainda não tem nenhuma tela que ela possa abrir. Peça a um administrador para conceder a área e as permissões do seu trabalho, no seu cargo ou no seu usuário. Assim que ele salvar, recarregue esta página.',
    'auth.semAcesso.contaRotulo': 'Conta',
    'auth.semAcesso.recarregar': 'Recarregar',
    'auth.semAcesso.sair': 'Sair',
  },
  en: {
    'auth.semAcesso.titulo': 'Your access does not include any area yet',
    'auth.semAcesso.explicacao':
      'The account is active, but no area of the system has been granted to it, or the granted area has no screen it can open yet. Ask an administrator to grant the area and the permissions your work needs, in your position or in your user. Once they save, reload this page.',
    'auth.semAcesso.contaRotulo': 'Account',
    'auth.semAcesso.recarregar': 'Reload',
    'auth.semAcesso.sair': 'Sign out',
  },
  es: {
    'auth.semAcesso.titulo': 'Su acceso todavía no incluye ningún área',
    'auth.semAcesso.explicacao':
      'La cuenta está activa, pero no se le liberó ningún área del sistema, o el área liberada todavía no tiene ninguna pantalla que pueda abrir. Pida a un administrador que conceda el área y los permisos de su trabajo, en su cargo o en su usuario. En cuanto guarde, recargue esta página.',
    'auth.semAcesso.contaRotulo': 'Cuenta',
    'auth.semAcesso.recarregar': 'Recargar',
    'auth.semAcesso.sair': 'Salir',
  },
}
